module.exports = __webpack_public_path__ + "87c7840a.svg";